import React, { useEffect, useState } from 'react'
import abbreviate from 'number-abbreviate';
import './AdvertiserDashboardCampaigns.css';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { useSelector } from 'react-redux'
import { getToken } from '../../../../features/token/tokenSaver';
import { getAdvertiserData } from '../../../../services/getAdvertiserData';
import { getAdvertiserCampaigns } from '../../../../services/getAdvertiserCampaigns';

export default function AdvertiserDashboardCampaigns(props) {
    const navigate = useNavigate();

    const [campaigns, setCampaigns] = useState([]);
    const token = useSelector(getToken)
    function parsed() {
        try {
            return JSON.parse(atob(token.split('.')[1]));
        } catch (e) {
            return null;
        }
    }
    useEffect(() => {
        const decoded = parsed();
        if (!decoded) return;
        getAdvertiserCampaigns(token, decoded.id).then(response => {
            if (response.data.data) {
                setCampaigns(response.data.data);
                console.log(response.data.data);
            }
        })
        return () => {

        }
    }, [token])

    return (

        <div className='advertiserDashboardContainerCampaigns'>
            <div className='adminDashboardScreenPageContainer'>
            <span className='registeredScreensTitle advertiserListTitle'>My Campaigns</span>
                <input type={"submit"} value={"+"} className='addAdvertiser' onClick={() => {
                    navigate("/advertiserDashboard/newCampaign")
                }} />

            <div className='adminDashboardScreensTableContainer'>
                {campaigns.length > 0 && <table className='adminDashboardScreensTable'>
                    <thead>
                        <tr>
                            <th>Id</th>
                            <th>Campaign Name</th>
                            <th>Status</th>
                            <th>Monthly Fee</th>
                        </tr>
                    </thead>
                    <tbody>
                        {campaigns.map((campaign) => {
                            const ended = campaign.SubscriptionEndDate
                                && !Number.isNaN(new Date(campaign.SubscriptionEndDate).getTime())
                                && new Date(campaign.SubscriptionEndDate).getTime() < Date.now();
                            return (
                            <tr onClick={() => { navigate("/advertiserDashboard/campaignDetails", { state: { adId: campaign.AdvertisementId } })}} key={campaign.AdvertisementId}>
                                <td>{campaign.AdvertisementId}</td>
                                <td>{campaign.AdvertisementName}</td>
                                <td>
                                    <span className={`statusBadge status-${ended ? 2 : campaign.StatusId}`}>
                                        {campaign.SubscriptionStatus === 'prepaid_reserved'
                                            ? 'Prepaid — upload creative'
                                            : ended
                                                ? 'Ended'
                                                : campaign.StatusId === 1
                                                    ? 'Active'
                                                    : campaign.StatusId === 3
                                                        ? 'Pending'
                                                        : 'Inactive'}
                                    </span>
                                </td>
                                <td>{campaign.MonthlyFee !== null && campaign.MonthlyFee !== undefined ? `$${Number(campaign.MonthlyFee).toFixed(2)}` : 'N/A'}</td>
                            </tr>
                            );
                        })}
                    </tbody>
                </table>}
                </div>
            </div>
        </div>
    )
}
